import { CreatePopulatedBlockRequest } from "models/interfaces/populated-blocks/create-populated-block-request";
import { CreatePopulatedBlockResponseRecord } from "models/view-models/populated-blocks/create-populated-block-response-record";
import ServiceHookFactory from "utilities/services/service-hook-factory";

const baseEndpoint = "populated-blocks";
const resourceType = CreatePopulatedBlockResponseRecord;

const PopulatedBlocksService = {
    useCreate: ServiceHookFactory.useCreateFromPostParams<
        CreatePopulatedBlockResponseRecord,
        CreatePopulatedBlockRequest
    >(resourceType, baseEndpoint),
};

export default PopulatedBlocksService;
